import { ref } from "vue";

const toasts = ref([]);
let toastId = 0;

export function useToast() {
  const removeToast = (id) => {
    toasts.value = toasts.value.filter((toast) => toast.id !== id);
  };

  const showToast = ({ message, type = "info", duration = 3000 }) => {
    const id = ++toastId;
    toasts.value = [...toasts.value, { id, message, type }];

    if (duration > 0) {
      window.setTimeout(() => {
        removeToast(id);
      }, duration);
    }

    return id;
  };

  return {
    toasts,
    showToast,
    removeToast
  };
}
